export default __webpack_public_path__ + "6d42e4294c821bb06b984527e7cb518a.svg";